<script setup>
import { useStore } from 'vuex'
import ProfileChip from '@/components/dike/ProfileChip.vue'
import SectionChip from '@/components/dikeSection/SectionChip.vue'
import { computed } from 'vue'

const props = defineProps({
  item: {},
  hideUnimportantItems: { type: Boolean, default: false }
})

const store = useStore()

const items = computed(() => store.state.stabSchematisation.items)
const showList = computed(() => store.state.stabSchematisation.showList)
const dikeProfileItems = computed(() => store.state.dikeProfiles.items)
const dikeSectionItems = computed(() => store.state.dikeSection.items)
const showOverview = computed(() => store.state.dikeProfiles.showOverview)
const currentOverviewItem = computed(() => store.state.stabSchematisation.currentOverviewItem)

const profile = computed(() =>
  dikeProfileItems.value.features.find((item) => item.id === props.item.dike_profile)
)
const section = computed(() =>
  dikeSectionItems.value.features.find(
    (item) => item.id === profile.value.properties.dikesection_id
  )
)
const years = computed(() => store.state.years.items)
const year = computed(() => years.value.find((item) => item.id === props.item.year))
const relatedItem = computed(() =>
  items.value.find((item) => item.id === props.item.linked_schematisation)
)

const setCurrentOverviewItem = (item) => {
  store.dispatch('stabSchematisation/setCurrentOverviewItem', item)
}
const setSelectedStabSchematisationStageId = (id) => {
  store.dispatch('dikeProfiles/setSelectedStabSchematisationStageId', id)
}

const setOverviewState = () => {
  setCurrentOverviewItem(props.item)
  setSelectedStabSchematisationStageId(props.item.latest_done_schematisation_stage)
}

const isSelected = (id) => {
  if (!showOverview.value) {
    return false
  }
  return currentOverviewItem.value?.id === id
}

defineEmits(['show', 'click-row'])
</script>

<template>
  <tr
    :ripple="true"
    density="compact"
    :selectable="false"
    @contextmenu="(setOverviewState(), $emit('show', $event))"
    @click.stop="setOverviewState()"
    :class="{
      'cursor-pointer': showOverview,
      'selected-item': isSelected(item.id)
    }"
  >
    <td v-if="hideUnimportantItems" />
    <td class="row-text px-2">
      <div @click="$emit('click-row', item)" style="max-width: 120px">
        <v-tooltip left>
          <template v-slot:activator="{ props }">
            <p
              v-bind="props"
              style="font-weight: bold"
              class="cursor-pointer text-primary overflow-text"
            >
              {{ item.name }}
            </p>
          </template>
          <span>{{ item.name }}</span>
        </v-tooltip>
      </div>
    </td>
    <td class="px-1" v-if="!hideUnimportantItems">
      <SectionChip v-if="showList" :item="section" :name="true" />
    </td>
    <td class="px-1" v-if="!hideUnimportantItems">
      <ProfileChip v-if="showList" :item="profile" :name="true" />
    </td>
    <td class="row-text px-2">
      {{ year ? year.year : null }}
    </td>
    <td class="row-text px-2">
      {{ item.stage_configuration_revision.name }}
    </td>
    <td class="row-text px-2">
      {{ item.soil_type_revision.name }}
    </td>
    <td class="row-text px-2">
      {{ item.water_line_rule_revision.name }}
    </td>

    <td class="row-text px-2">
      <div @click="$emit('click-row')" style="max-width: 60px">
        <v-tooltip left>
          <template v-slot:activator="{ props }">
            <p class="ma-0 overflow-text" v-bind="props" style="font-weight: 450; font-size: 12px">
              {{ relatedItem ? relatedItem.name : null }}
            </p>
          </template>
          <span>{{ relatedItem ? relatedItem.name : null }}</span>
        </v-tooltip>
      </div>
    </td>
    <td class="row-text text-center px-2">
      <span>{{ item.stages_done }} / {{ item.length_stages }}</span>
    </td>
  </tr>
</template>
<style scoped>
.truncate {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
}
.row-text {
  font-size: 12px;
}
</style>
